var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"fixed":""}},[_vm._t("left",null,{"slot":"left"}),_vm._t("title",null,{"slot":"title"}),_vm._t("default",null,{"slot":"right_side"}),_vm._t("right",null,{"slot":"right"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }